import { useRef } from "react";
import { useIsoMorphicEffect as n } from "./use-iso-morphic-effect.js";
function f() {
  let e = useRef(false);
  return n(() => (e.current = true, () => {
    e.current = false;
  }), []), e;
}
export {
  f as useIsMounted
};
